/* eslint no-unused-vars: 0 */
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container, isCollapsible = false) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    // for the menu drawer, when clicking on the 'view all' button, the focus is lost, because the last item doesn't exist anymore, so we have to redefine the last item to be the last list item
    if (isCollapsible) {
      container.querySelectorAll('.hidden > a')[0].focus();
      last = Array.from(container.querySelectorAll('.hidden > a')).slice(-1)[0];
      isCollapsible = false;
    }
  };

  trapFocusHandlers.keydown = function (event) {
    if (event?.code?.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

/**
 * Prevent page scroll when a modal is visible on mobile devices
 */
function preventDefault(e) {
  e.preventDefault();
}

let scrollY; // we'll store the scroll position here

/**
 *
 * @param {*} modal Object. Preferably an element with an ID
 * @returns
 */
function showModal(modal) {
  if (!modal) return;

  // don't apply the prevent-scroll for filters on larger screens
  if (modal.id === 'CollectionFiltersForm') return;

  // remember scroll position
  scrollY = window.scrollY;

  // prevent the body from jumping when the position fixed is added and wait to make sure it's been added
  document.body.style.top = `${scrollY < window.innerHeight ? 0 - scrollY : 0}px`;
  setTimeout(() => {
    document.documentElement.classList.add('prevent-scroll');
  }, 100);

  modal.addEventListener('pointermove', preventDefault);
}

/**
 *
 * @param {*} modal Object. Should be the same as passed above
 * @returns
 */
function hideModal(modal, restoreScrollPosition = true) {
  if (!modal) return;

  modal.removeEventListener('pointermove', preventDefault);
  document.documentElement.classList.remove('prevent-scroll');
  document.body.style.top = 0;
  // restore scroll position
  if (restoreScrollPosition) {
    window.scrollTo(0, scrollY);
  }
}

// debug function check, returns true when on localhost or myshopify.com domain
const debug = () =>
  window.location.hostname === '127.0.0.1' || window.location.hostname.indexOf('myshopify.com') !== -1;

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

/**
 * Create custom addEventListener to also keep track of the event listeners
 * @param {Object[]} array Array of Class to add the event listener to
 * @param {HTMLElement} target Element to add the event listener to
 * @param {string} eventType Event type for the event listener
 * @param {Function} callback Callback function for the event listener
 */
function addAndTrackEventListener(array, target, eventType, callback) {
  target.addEventListener(eventType, callback);
  array.push({ target, eventType, callback });
}

/**
 * Create remove all event listeners to clear all event listeners
 * @param {Object[]} array Array of Class to remove the event listener from
 */
function removeAllEventListeners(array) {
  array.forEach(({ target, eventType, callback }) => {
    target.removeEventListener(eventType, callback);
  });
  return [];
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    // prevent 0 from being a valid value
    this.input.addEventListener('blur', () => {
      if (this.input.closest('cart-items')) return;

      const isNotZero = /^(?!0)\d+$/.test(this.input.valueAsNumber);
      if (!isNotZero) this.input.value = 1;
      this.input.dispatchEvent(this.changeEvent);
    });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.valueAsNumber;
    const errorMsgWrapper = this.closest('.cart-item')?.querySelector('.cart-item__error-text');

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.valueAsNumber) {
      this.input.dispatchEvent(this.changeEvent);
    }

    // show an error message in the cart (drawer) when the max items have already been added
    if (previousValue === this.input.valueAsNumber && this.input.valueAsNumber == this.input.max && errorMsgWrapper) {
      errorMsgWrapper.innerHTML = window.cartStrings.quantityError.replace('[quantity]', this.input.max);

      // clear the element again
      setTimeout(() => {
        errorMsgWrapper.innerHTML = '';
      }, 3000);
    }
  }
}
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json', application = 'json', domain = window.routes.permanent_domain) {
  return {
    method: 'POST',
    headers: {
      'Content-Type': `application/${application}`,
      Accept: `application/${type}`,
      'x-shopify-shop-domain': `${domain}`,
    },
  };
}

// Cookie functions
function setCookie(name, value, age = 90) {
  const cookieVal = `${name}=${encodeURI(value)}; path=/; max-age=${60 * 60 * 24 * age}`;
  document.cookie = cookieVal;
}

function getCookie(name) {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];
  return cookie ? JSON.parse(decodeURI(cookie)) : false;
}

function removeCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function getNodeIndex(node) {
  return Array.from(node.parentNode.children).indexOf(node);
}

// back to top button
document.querySelectorAll('[data-back-to-top]').forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: 'smooth' });
  });
});

document.querySelectorAll('.prevent-hashjump').forEach((link) => {
  link.addEventListener('click', (e) => {
    if (link.hash) {
      const targetElem = document.querySelector(link.hash);
      if (targetElem) {
        const scrollTop = window.pageYOffset;

        window.scrollTo({ top: scrollTop });
        setTimeout(function () {
          window.scrollTo({ top: scrollTop });
        }, 1);
      }
    }
  });
});

// animate scroll to anchor. Add data-offset to the 'a' element to add an offset
document.querySelectorAll('a[href^="#"]').forEach((link) => {
  if (link.classList.contains('prevent-hashjump')) {
    return;
  }

  link.addEventListener('click', (e) => {
    // skiplinks just jump
    if (link.hash === '' || link.classList.contains('skip-to-content-link')) {
      // for product card links, don't jump, just focus
      if (link.hash.indexOf('productCardLink-') !== -1) {
        e.preventDefault();
        document.querySelector(e.currentTarget.hash).focus();
      }
      return;
    }
    let offset = 0;
    if (link.dataset?.offset) {
      offset = parseInt(link.dataset.offset);
    }
    e.preventDefault();
    let target = document.querySelector(e.currentTarget.hash);
    let topOffset = target.getBoundingClientRect().top;

    // for the variant link on the PDP, add an exception
    if (link.hash === '#block-variants' || link.hash === '#block-reviews') {
      if (!document.body.classList.contains('header--visible')) {
        topOffset -= 84;
        if (window.innerWidth >= 1024) {
          topOffset -= 64;
        }
      }
    }

    while (target !== document.documentElement) {
      target = target.parentElement;
      topOffset += target.scrollTop;
    }

    window.scrollTo({ top: topOffset - offset, behavior: 'smooth' });
  });
});

/**
 * Prevent default behavior on all buttons with the [data-go-to-cart-button] attribute, so we can track the add event.
 */
function goToCartEvent(buttons) {
  const goToCartButtons = buttons ? buttons : document.querySelectorAll('[data-go-to-cart-button]');

  goToCartButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      // Prevent default location change
      event.preventDefault();

      // Fire tracking event
      window.tealium.useTealium && tealiumGoToCart();

      // Get the href and go to the location
      window.location.href = event.target.href;
    });
  });
}
goToCartEvent();

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt2 = document.createElement('option');
        opt2.value = provinces[i][0];
        opt2.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt2);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
